import { render, staticRenderFns } from "./allow-ip.vue?vue&type=template&id=1f215619&"
import script from "./allow-ip.vue?vue&type=script&lang=js&"
export * from "./allow-ip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports